import { FunctionComponent } from "react";
import TemplateForm from "./TemplateForm";

interface ICreateEditTemplateFormProps {
    template?: any
    isBusiness?: boolean
    formType: string,
    duplicate?: boolean,
    onMessageSaveHandler?: (e: string) => void,
    onCloseHandler?: () => void
}

const CreateEditTemplateForm: FunctionComponent<ICreateEditTemplateFormProps> = ({
    template, 
    isBusiness, 
    formType, 
    duplicate = false, 
    onMessageSaveHandler, 
    onCloseHandler
}) => {
    return (
        <TemplateForm
            template={template}
            isBusiness={isBusiness}
            formType={formType}
            duplicate={duplicate}
            onMessageSaveHandler={onMessageSaveHandler}
            onCloseHandler={onCloseHandler}
            showNameField={formType === 'template'}
            showPrivateField={formType === 'template'}
        />
    )
}
export default CreateEditTemplateForm